'use client'

import * as React from 'react'
import type { UseRefinementListProps } from 'react-instantsearch'

import { useContentSearchCategoryQuery } from '@web/gen/content'
import { SearchableFilters } from '@web/components/content-api/search-page/utils'
import { SidebarFilter } from './sidebar-filter'
import { useSearchPageContext } from '@web/components/algolia/providers/content-api-search-page-provider'
import { mapCategoryPageTypeToCategoryDetails } from '@web/components/content-api/config'

export function CategoriesSidebarFilter({
  header,
  showLessText,
  showMoreText,
}: {
  header: string
  showMoreText: string
  showLessText: string
}) {
  const { expanded, contentLanguage } = useSearchPageContext()

  const { data } = useContentSearchCategoryQuery({
    name: '',
    parentId: mapCategoryPageTypeToCategoryDetails.stockphotos.parentId,
    language: contentLanguage,
  })

  const normalizeCategories: Record<string, { id: string; name: string; slug: string }> = {}

  data?.contentSearchCategory?.forEach(element => {
    normalizeCategories[element.id] = element
  })

  const transformCategories: UseRefinementListProps['transformItems'] = items => {
    const itemData = items.map(item => {
      return {
        ...item,
        label: normalizeCategories[item.value]?.name || '',
      }
    })

    return itemData
  }

  //eslint-disable-next-line react-hooks/exhaustive-deps
  const memoedTransformCategories = React.useCallback(transformCategories, [
    data?.contentSearchCategory,
  ])

  return (
    <SidebarFilter
      transformItems={memoedTransformCategories}
      isExpanded={expanded ? expanded.includes(SearchableFilters.CATEGORY) : undefined}
      showLessText={showLessText}
      showMoreText={showMoreText}
      attribute={`${SearchableFilters.CATEGORY}`}
      header={header}
    />
  )
}
